import Vue from 'vue'
import i18n from '@/lang/i18n'

export default [
  {
    path: '/point/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: 'orderFood', // 點餐(舊)
        name: 'pointOrderFood',
        component: () => import('@/views/Point/OrderFood/OrderFoodView.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: 'orderFoodV2', // 點餐(新)
        name: 'orderFoodV2',
        component: () => import('@/views/Point/OrderFood/OrderFood.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: 'orderFoodItemManagement',
        name: 'orderFoodItemManagement',
        component: () => import('@/views/Point/OrderFood/OrderFoodItemManagement.vue'),
        meta: {
          prev: 'orderFoodV2',
          fromPage: '' // 來源頁面
        },
        beforeEnter: (to, from, next) => {
          to.meta.fromPage = from.name
          next()
        }
      },
      {
        path: 'orderFoodMenuEdit/:id',
        name: 'orderFoodMenuEdit',
        component: () => import('@/views/Point/OrderFood/OrderFoodMenuEdit.vue'),
        meta: {
          prev: 'orderFoodItemManagement'
        }
      },
      {
        path: 'orderFoodSpecEdit/:id',
        name: 'orderFoodSpecEdit',
        component: () => import('@/views/Point/OrderFood/OrderFoodSpecEdit.vue'),
        meta: {
          prev: 'orderFoodItemManagement'
        }
      },
      {
        path: 'orderFoodRecordList',
        name: 'orderFoodRecordList',
        component: () => import('@/views/Point/OrderFood/OrderFoodRecordList.vue'),
        meta: {
          prev: 'orderFoodV2'
        }
      },
      {
        path: 'orderFoodRecord', // 點餐紀錄(舊)
        name: 'pointOrderFoodRecord',
        component: () => import('@/views/Point/OrderFood/OrderFoodRecord.vue'),
        meta: {
          prev: 'pointOrderFood',
          title: i18n.t('OrderFoodRecord.Title'),
          tip: i18n.t('OrderFoodRecord.Tip')
        },
        beforeEnter: (to, from, next) => {
          /**
           * 處理以下情境:
           * 1. 透過舊點餐頁面的「點餐紀錄」按鈕進入
           * 2. 透過新點餐紀錄頁面的「舊點餐紀錄」按鈕進入
           * 配合「上一頁」按鈕的功能
           */
          if (from.name) to.meta.prev = from.name
          // 如果是從新點餐紀錄頁面進入
          if (from.name === 'orderFoodRecordList') {
            to.meta.title = i18n.t('OrderFoodRecord.TitleHistory')
            to.meta.tip = i18n.t('OrderFoodRecord.TipHistory')
          }
          next()
        }
      },
      {
        path: 'orderFoodExportReport',
        name: 'orderFoodExportReport',
        component: () => import('@/views/Point/OrderFood/OrderFoodExportReport.vue'),
        meta: {
          prev: 'orderFoodRecordList'
        }
      },
      {
        path: 'report',
        name: 'pointReport',
        component: () => import('@/views/Point/ReportView.vue'),
        meta: {
          prev: 'mainPage/pointManage'
        }
      },
      {
        path: 'noteTemplate',
        name: 'noteTemplate',
        component: () => import('@/views/Point/NoteTemplate.vue'),
        meta: {
          prev: 'mainPage/pointManage'
        }
      }
    ],
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('loginUserInfo') && !JSON.parse(localStorage.getItem('loginUserInfo'))) {
        Vue.prototype.$alert('請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          next({ name: 'LoginMain' })
        })
      } else {
        // 非 prod 環境時，設定為 QA 測試的時間
        const forceNewDate = process.env.VUE_APP_ENV !== 'prod' ? '2025/03/19' : '2025/04/01'
        // 可能有管理員已將此路由加入書籤(舊版點餐)，所以仍需要依照時間判斷是否導向新版點餐
        if (to.path === '/point/orderFood' && new Date() > new Date(forceNewDate)) {
          next({ name: 'orderFoodV2' }) // 前往新版頁面
        } else {
          next()
        }
      }
    }
  }
]
